import { z } from "zod";

export const deviceLocationSchema = z.strictObject({
  latitude: z
    .float32()
    .min(-90)
    .max(90)
    .describe("Latitude in decimal degrees, -90 to +90"),
  longitude: z
    .float32()
    .min(-180)
    .max(180)
    .describe("Longitude in decimal degrees, -180 to +180"),
  altitude: z
    .float32()
    .describe(
      "Altitude in meters as reported by the GNSS receiver. " +
        "Typically meters above mean sea level (MSL) if the module applies a geoid model, " +
        "otherwise meters above the WGS-84 ellipsoid.",
    ),
  accuracy: z.float32().nonnegative().describe("Estimated accuracy in meters"),
  timeToFirstFix: z
    .uint32()
    .nonnegative()
    .describe("Time to first fix, in seconds"),
});
